export const ADMIN_LANDING_REMINDER = 'ADMIN_LANDING_REMINDER';
export const CATEGORY_REMINDER = 'CATEGORY_REMINDER';
export const HE_LANDING_REMINDER = 'HE_LANDING_REMINDER';
export const BFCP_LIVE = 'BFCP_LIVE';
export const BFCP_HE_LOCK='BFCP_HE_LOCK';
export const LEGAL_NOTICE='LEGAL_NOTICE';
export const AY='AY';
export const ANNOUNCEMENT='ANNOUNCEMENT';